import React from 'react';
import { Upload } from 'lucide-react';
import { Button } from '../../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

const ImportListCard = ({ onOpen }) => (
  <Card className="import-card">
    <CardHeader>
      <CardTitle className="email-card-title">
        <Upload size={20} />
        Import Email List
      </CardTitle>
    </CardHeader>
    <CardContent>
      <p className="import-description">Import emails from Leaguelineup or other sources.</p>
      <Button onClick={onOpen} className="import-btn">
        <Upload size={16} />
        Import CSV / List
      </Button>
    </CardContent>
  </Card>
);

export default ImportListCard;
